<template>
  <div>
    <div class="admin-editing-page" :class="{ 'mb-15 ml-15 mr-30' : ShouldDisplayNewPricingPlanWidget}">
      <div class="col left" :class="{'bg-white' : ShouldDisplayNewPricingPlanWidget}">
        <div class="row mb-30">
          <div class="col left">
            {{ $t("AccountManager") }}
          </div>
          <div class="col">
            <sb-dropdown
              v-model="accountExecutiveSelection"
              :options="adminPageData.AccountManagers"
            >
              <sb-selected-option slot="selection" slot-scope="{ selected }">
                {{ selected.FullName }}
              </sb-selected-option>
              <sb-options>
                <sb-option slot-scope="{ option }" :value="option">
                  {{ option.FullName }}
                </sb-option>
              </sb-options>
            </sb-dropdown>
          </div>
        </div>
        <div class="row mb-30">
          <div class="col left">
            {{ $t("SupportManager") }}
          </div>
          <div class="col">
            <sb-dropdown
              v-model="supportManagerSelection"
              :options="adminPageData.SupportManagers"
            >
              <sb-selected-option slot="selection" slot-scope="{ selected }">
                {{ selected.FullName }}
              </sb-selected-option>
              <sb-options>
                <sb-option slot-scope="{ option }" :value="option">
                  {{ option.FullName }}
                </sb-option>
              </sb-options>
            </sb-dropdown>
          </div>
        </div>
        <div class="row mb-30">
          <div class="col left">
            {{ $t("ImplementationManager") }}
          </div>
          <div class="col">
            <sb-dropdown
              v-model="implementationManagerSelection"
              :options="adminPageData.ImplementationManagers"
            >
              <sb-selected-option slot="selection" slot-scope="{ selected }">
                {{ selected.FullName }}
              </sb-selected-option>
              <sb-options>
                <sb-option slot-scope="{ option }" :value="option">
                  {{ option.FullName }}
                </sb-option>
              </sb-options>
            </sb-dropdown>
          </div>
        </div>
        <div v-if="!ShouldDisplayNewPricingPlanWidget" class="pricingPlan">
          <div class="row mb-30">
            <div class="col left">
              {{ $t("CurrentDomesticPricing") }}
            </div>
            <div class="col">
              {{
                adminPageData.DomesticPricingPlan.PlanName ||
                  $t("NoneSelected")
              }}
            </div>
          </div>
          <div class="row mb-30">
            <div class="col left">
              {{ $t("ChangeDomesticPricing") }}
            </div>
            <div class="col">
              <sb-dropdown
                v-model="domesticPricingPlanSelection"
                :options="adminPageData.PricingPlans"
                placeholder="-- select new plan --"
              >
                <sb-selected-option slot="selection" slot-scope="{ selected }">
                  {{ selected.PlanName }}
                </sb-selected-option>
                <sb-options>
                  <sb-option slot-scope="{ option }" :value="option">
                    {{ option.PlanName }}
                  </sb-option>
                </sb-options>
              </sb-dropdown>
            </div>
          </div>
        </div>
        <div v-if="!ShouldDisplayNewPricingPlanWidget" class="pricingPlan">
          <div class="row mb-30">
            <div class="col left">
              {{ $t("CurrentInternationalPricing") }}
            </div>
            <div class="col">
              {{
                adminPageData.InternationalPricingPlan.PlanName ||
                  $t("NoneSelected")
              }}
            </div>
          </div>
          <div class="row mb-30">
            <div class="col left">
              {{ $t("ChangeInternationalPricing") }}
            </div>
            <div class="col">
              <sb-dropdown
                v-model="internationalPricingPlanSelection"
                :options="adminPageData.PricingPlans"
                placeholder="-- select new plan --"
              >
                <sb-selected-option slot="selection" slot-scope="{ selected }">
                  {{ selected.PlanName }}
                </sb-selected-option>
                <sb-options>
                  <sb-option slot-scope="{ option }" :value="option">
                    {{ option.PlanName }}
                  </sb-option>
                </sb-options>
              </sb-dropdown>
            </div>
          </div>
        </div>
      </div>
      <div class="col heads-up-wrapper" :class="{'bg-white' : ShouldDisplayNewPricingPlanWidget}">
        <div class="warning-content">
          <p>{{ $t("HeadsUp") }}</p>
          <p>{{ $t("SavingChanges") }}</p>
          <p>{{ $t("Caution") }}</p>
        </div>
        <div class="button">
          <sb-button
            v-t="saveButtonTextKey"
            variation="primary"
            class="save-btn"
            @click.prevent="handleSave"
          />
        </div>
      </div>
    </div>
    <div>
      <div v-if="ShouldDisplayNewPricingPlanWidget" :style="[!isDataReady ? {'display': 'none'} : {}]">
        <div v-if="showLocalCurrencyWithSymbolAndCode" class="mb-15 ml-15 mr-30 bg-white" style="border-radius: 5px;">
          <div class="table-title">
            ShipBob Network Pricing and Currency
            <div class="sub-header">
              The dashboard displays the currency of the country marked as 'home'
            </div>
          </div>
          <div>
            <UserHomeAndPlanAssignmentTable
              :rows="SFNUserPricingPlans"
              :loading="loadingAllCountriesData"
              :home-country-currency="homeCountryCurrency"
              @handleEditPricingPlan="handleEditPricingPlan"
              @handleSwitchHomeCountryModalOpen="handleSwitchHomeCountryModalOpen"
            />
          </div>
        </div>
        <div v-else class="mb-15 ml-15 mr-30 bg-white" style="border-radius: 5px;">
          <div class="table-title">
            ShipBob Network Pricing
          </div>
          <div>
            <UserPlanAssignmentTable :rows="SFNUserPricingPlans" @handleEditPricingPlan="handleEditPricingPlan" />
          </div>
        </div>
        <div v-if="ShowMerchantPlusPlanTable" class="mb-15 ml-15 mr-30 bg-white" style="border-radius: 5px;">
          <div class="table-title">
            Merchant+ Pricing
          </div>
          <div style="float: right; margin:0.8rem;">
            <sb-button class="save-btn" style="background-color: #fff; color: #2570AF; font-weight: 600; box-shadow: none;" @click="handleAssignNewPlan">
              Assign New Plan
            </sb-button>
          </div>
          <div>
            <UserPlanAssignmentTable :rows="MerchantPlusUserPricingPlanModel" :is-merchant-plus-view="true" @handleEditPricingPlan="handleEditPricingPlan" />
          </div>
        </div>
      </div>

      <drawer-wrapper
        :active.sync="showAssignNewPlanDialog"
        class="admin-plan-panel__drawer"
      >
        <AssignNewPlan />
      </drawer-wrapper>
      <drawer-wrapper
        :active.sync="showEditPricingPlanDialog"
        class="admin-plan-panel__drawer"
      >
        <EditPricingPlan />
      </drawer-wrapper>
      <SwitchHomeCountryModal
        v-if="showSwitchHomeCountryModal"
        :is-visible="showSwitchHomeCountryModal"
        :on-close="handleSwitchHomeCountryModalClose"
        :selected-row="selectedRow"
        @handleSwitchHomeCountry="handleSwitchHomeCountry"
      />
    </div>
  </div>
</template>
<script>
import toastr from 'toastr'
import EditPricingPlan from './panels/EditPricingPlanPanel.vue'
import AssignNewPlan from './panels/AssignNewPlanPanel.vue'
import UserPlanAssignmentTable from './panels/UserPlanAssignmentTable.vue'
import UserHomeAndPlanAssignmentTable from './panels/UserHomeAndPlanAssignmentTable.vue'
import SwitchHomeCountryModal from './panels/SwitchHomeCountryModal.vue'
import { LocationsService } from '@services/pricing/locations'
import AdminService from '@/services/admin'
export default {
  name: 'AdminEditingPage',
  components: {
    UserPlanAssignmentTable,
    EditPricingPlan,
    AssignNewPlan,
    UserHomeAndPlanAssignmentTable,
    SwitchHomeCountryModal
  },
  data () {
    return {
      datastoreLocation: 'admin/',
      saving: false,
      showAssignNewPlanDialog: false,
      showEditPricingPlanDialog: false,
      isDataReady: false,
      showSwitchHomeCountryModal: false,
      loadingAllCountriesData: true,
      selectedRow: []
    }
  },
  computed: {
    adminPageData () {
      return this.$shipBobStore.getters['admin/adminPageData']
    },
    impersonatedUserInfo () {
      return this.$shipBobStore.getters['user/getUserForAdminPage']
    },
    homeCountryCurrency: {
      get () {
        return this.$shipBobStore.getters['pricing/userHomeCountry']
      }
    },
    showLocalCurrencyWithSymbolAndCode () {
      return this.$shipBobStore.getters.showLocalCurrencyWithSymbolAndCode
    },
    accountExecutiveSelection: {
      get () {
        return this.adminPageData.AccountManager
      },
      set (selection) {
        this.$shipBobStore.dispatch(
          'admin/setAccountExecutive',
          selection.UserId
        )
      }
    },
    supportManagerSelection: {
      get () {
        return this.adminPageData.SupportManager
      },
      set (selection) {
        this.$shipBobStore.dispatch(
          'admin/setSupportManager',
          selection.UserId
        )
      }
    },
    implementationManagerSelection: {
      get () {
        return this.adminPageData.ImplementationManager
      },
      set (selection) {
        this.$shipBobStore.dispatch(
          'admin/setImplementationManager',
          selection.UserId
        )
      }
    },
    domesticPricingPlanSelection: {
      get () {
        if (this.adminPageData.SelectedDomesticPricingPlan.PlanId === null) { return null } else return this.adminPageData.SelectedDomesticPricingPlan
      },
      set (selection) {
        this.$shipBobStore.dispatch(
          'admin/setSelectedDomesticPricingPlan',
          selection.PlanId
        )
      }
    },
    internationalPricingPlanSelection: {
      get () {
        if (this.adminPageData.SelectedInternationalPricingPlan.PlanId === null) { return null } else return this.adminPageData.SelectedInternationalPricingPlan
      },
      set (selection) {
        this.$shipBobStore.dispatch(
          'admin/setSelectedInternationalPricingPlan',
          selection.PlanId
        )
      }
    },
    saveButtonTextKey () {
      return this.saving ? 'Saving' : 'Save'
    },
    ShouldDisplayNewPricingPlanWidget () {
      return this.$shipBobStore.getters.shouldDisplayNewPricingPlanWidget
    },
    SFNUserPricingPlans: {
      get () {
        const plans = this.$shipBobStore.getters['admin/SFNUserPricingPlanModel']
        if (plans != null) { this.handleIsDataReady(true) }
        return plans ?? []
      }
    },
    MerchantPlusUserPricingPlanModel: {
      get () {
        const plans = this.$shipBobStore.getters[
          'admin/MerchantPlusUserPricingPlanModel'
        ]
        if (plans != null) { this.handleIsDataReady(true) }
        return plans ?? []
      }
    },
    ShowMerchantPlusPlanTable: {
      get () {
        const userMerchantPlusFcs = this.$shipBobStore.getters[
          'admin/userMerchantPlusFcs'
        ]
        return Array.isArray(userMerchantPlusFcs) && userMerchantPlusFcs.length > 0
      }
    }
  },
  created () {
    this.$shipBobStore.dispatch('admin/getAdminPageData')
    if (this.$shipBobStore.getters.shouldDisplayNewPricingPlanWidget) {
      this.$shipBobStore.dispatch('admin/getUserPricingPlans')
      this.$shipBobStore.dispatch('admin/getAllAssignablePlans')
    }
  },
  methods: {
    async handleSave () {
      if (this.saving) return
      this.saving = true
      const success = await this.$shipBobStore.dispatch(
        'admin/updateAdminPageData'
      )
      this.saving = false
      if (success) toastr.success(this.$t('SavedSuccessfully'))
    },
    handleAssignNewPlan () {
      this.showAssignNewPlanDialog = true
    },
    handleIsDataReady (isDataReady) {
      this.isDataReady = isDataReady
    },
    handleEditPricingPlan (IsMerchantPlusView, row) {
      this.$shipBobStore.dispatch('admin/setSelectedRowData', { editShipBobNetworkPlan: !IsMerchantPlusView, rowData: row })
      this.showEditPricingPlanDialog = true
    },
    handleSwitchHomeCountryModalOpen (row) {
      this.$shipBobStore.dispatch('addPromise', {
        promise: LocationsService.getAllCountryCurrency(),
        scopes: ['getAllCountryCurrencyData']
      })
      this.selectedRow = row
      this.showSwitchHomeCountryModal = true
    },
    handleSwitchHomeCountryModalClose () {
      this.showSwitchHomeCountryModal = false
    },
    async handleSwitchHomeCountry (countryCode) {
      this.$shipBobStore.dispatch('addPromise', {
        promise: AdminService.saveHomeCountry(countryCode),
        scopes: ['saveHomeCountry']
      })
    }
  },
  i18n: {
    messages: {
      'en-US': {
        HeadsUp: 'Heads Up!',
        SavingChanges:
          "Saving any changes on this page may impact this merchant's pricing plan and ShipBob personnel assigned to each account.",
        Caution:
          'Proceed with caution and check with your manager if you have any questions.',
        Save: 'Save Changes',
        Saving: 'Saving...',
        SavedSuccessfully: 'Changes saved',
        AccountManager: 'Account Executive',
        CurrentDomesticPricing: 'Current Domestic Pricing Plan',
        ChangeDomesticPricing: 'Change Domestic Pricing Plan to',
        CurrentInternationalPricing: 'Current International Pricing Plan',
        ChangeInternationalPricing: 'Change International Pricing Plan to',
        SupportManager: 'Support Manager',
        ImplementationManager: 'Implementation Manager',
        NoneSelected: 'None selected'
      }
    }
  }
}
</script>
<style lang="scss" scoped>
@import "@/../assets/scss/shipbob-custom/components/admin/_admin_editing.scss";
@import "./panels/admin-plan-panel.scss";
</style>
